import React, { useState } from "react";
import axios from "../../api/axios";
import ReportFilter from "./components/ReportFilter";

const TopSellingPropertiesReport = () => {
  const [filters, setFilters] = useState({});
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchReport = async () => {
    setLoading(true);
    try {
      const res = await axios.get("/api/reports/top-selling-properties", {
        params: filters,
      });
      setRows(res.data.data || []);
    } catch (err) {
      console.error("Failed to load top selling properties", err);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  const download = async (type) => {
    try {
      const res = await axios.get(`/api/reports/top-selling-properties/${type}`, {
        params: filters,
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `top-selling-properties-report.${type === "csv" ? "csv" : "pdf"}`);
      document.body.appendChild(link);
      link.click();
    } catch (err) {
      console.error(`Failed to download ${type}`, err);
    }
  };

  return (
    <div className="container py-4">
      <h4 className="fw-bold mb-3">Top Selling Properties</h4>

      <ReportFilter filters={filters} setFilters={setFilters} onSearch={fetchReport} />

      <div className="card mb-3">
        <div className="card-body row g-3">
          <div className="col-md-3">
            <label className="form-label">Sort By</label>
            <select
              className="form-select"
              value={filters.sort_by || "sold_units"}
              onChange={(e) => setFilters({ ...filters, sort_by: e.target.value })}
            >
              <option value="sold_units">Sold Units</option>
              <option value="revenue">Revenue</option>
            </select>
          </div>
          <div className="col-md-3">
            <label className="form-label">Direction</label>
            <select
              className="form-select"
              value={filters.sort_dir || "desc"}
              onChange={(e) => setFilters({ ...filters, sort_dir: e.target.value })}
            >
              <option value="desc">Desc</option>
              <option value="asc">Asc</option>
            </select>
          </div>
          <div className="col-md-3">
            <label className="form-label">Limit</label>
            <input
              type="number"
              className="form-control"
              min="1"
              max="100"
              value={filters.limit || 10}
              onChange={(e) => setFilters({ ...filters, limit: e.target.value || undefined })}
            />
          </div>
          <div className="col-md-3 d-flex align-items-end justify-content-end gap-2">
            <button className="btn btn-primary" onClick={fetchReport}>
              {loading ? "Loading..." : "Search"}
            </button>
            <button className="btn btn-outline-danger" onClick={() => download("pdf")}>
              PDF Download
            </button>
            <button className="btn btn-outline-secondary" onClick={() => download("csv")}>
              CSV Download
            </button>
          </div>
        </div>
      </div>

      <div className="card shadow-sm">
        <div className="card-body table-responsive">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Property</th>
                <th>Area</th>
                <th>Sold Units</th>
                <th>Revenue</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 ? (
                <tr>
                  <td colSpan="4" className="text-center">
                    {loading ? "Loading..." : "No data"}
                  </td>
                </tr>
              ) : (
                rows.map((row, idx) => (
                  <tr key={idx}>
                    <td>{row.property_name}</td>
                    <td>{row.area || "—"}</td>
                    <td>{row.sold_units}</td>
                    <td>{Number(row.revenue || 0).toFixed(2)}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default TopSellingPropertiesReport;

